export default __webpack_public_path__ + "7a7aabebd911c5c7373c843af2ac433d.svg";